<template>
  <div class="login1">
    <div class="login3">
      <div class="login4">
        <div class="login_logo"><img src="../assets/logo.png"></div>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="green"
        ></v-progress-linear>
        <div class="usr_login">
          <v-form v-on:submit.prevent="submit">
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="username"
                    label="Username"
                    :error-messages="usernameErrors"
                    @input="$v.username.$touch()"
                    @blur="$v.username.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    @click:append="showPassword = !showPassword"
                    :error-messages="passwordErrors"
                    @input="$v.password.$touch()"
                    @blur="$v.password.$touch()"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                  class="text-center"
                >
                  <v-btn type="submit" color="rtsPrimary" @click="submit" :loading="loading">Log In</v-btn>
                  <!-- <v-btn class="mr-4" @click="submit">submit</v-btn> -->
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </div>
        <twoFAModal v-if="show2FA" :showPopup="show2FA" :loginResponse="loginResponse" :closePopup="close2FAPopup"/>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { LOGIN } from '../store/actions.type'
import twoFAModal from '../components/twoFactorAuthenticationModal.vue'

export default {
  mixins: [validationMixin],
  validations: {
    username: { required },
    password: { required }
  },
  name: 'LoginComponent',
  props: {
    msg: String
  },
  components: {
    twoFAModal
  },
  data () {
    return {
      valid: true,
      username: null,
      password: null,
      showPassword: false,
      loading: false,
      loginResponse: null,
      show2FA: false
    }
  },
  computed: {
    usernameErrors () {
      const errors = []
      if (!this.$v.username.$dirty) return errors
      !this.$v.username.required && errors.push('Username is required.')
      return errors
    },
    passwordErrors () {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      return errors
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$store.state.auth.errorMessage = null
        this.$store.state.auth.errorType = null
        this.$store.dispatch(LOGIN, { username: this.username, password: this.password }).then((response) => {
          this.loading = false
          if (!response.user_data) {
            this.loginResponse = {
              qrCodeUrl: response.qr_image_url,
              is2FAEnabled: response.is_verified,
              username: this.username,
              password: this.password
            }
            this.show2FA = true
          } else if (this.$store.state.auth.errors == null) {
            this.$router.push(`/`)
          }
        }).catch(({ response }) => {
          this.loading = false
        })
      }
    },
    clear () {
      this.$v.$reset()
      this.username = null
      this.password = null
      this.show2FA = false
    },
    close2FAPopup () {
      this.show2FA = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .login1 {
    width: 100%;
    height: 100%;
    vertical-align: middle;
    display: table-cell;
    background-color: #69a58b;
  }

  .login3 {
    width: 550px;
    margin: auto;
    background-color: #FFF;
    border: #E6E6E6 solid 1px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
    -moz-box-shadow: 3px 3px 3px 0px rgba(50, 50, 50, 0.6);
    box-shadow: 3px 3px 3px 0px rgba(50, 50, 50, 0.6);
  }

  .login_logo {
    text-align: center;
    padding-top: 10px;
    border-bottom: 2px solid #EFEFEF;
    padding-bottom: 10px;
    background-color: #F0F0F0;
  }

  .usr_login {
    padding-top: 20px;
    padding-bottom: 20px;
  }
</style>
